import { render, staticRenderFns } from "./NewMatrixType.vue?vue&type=template&id=4ba15d01&"
import script from "./NewMatrixType.vue?vue&type=script&lang=js&"
export * from "./NewMatrixType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports